<template>
  <div class="pagination" :class="{ 'pagination--center': center }">
    <PerPageSelect
      v-if="showPerPage"
      :value="selectedPerPage"
      :items="perPageOptions"
      :disabled="disabled"
      @change="onPerPageChange"
    />

    <div class="pagination__nav">
      <v-btn
        icon
        :disabled="page <= 1 || disabled"
        @click="$emit('page-change', page - 1)"
      >
        <v-icon size="24">mdi-chevron-left</v-icon>
      </v-btn>

      <div class="pagination__counter">
        {{ $t("message.common.page", [page]) }}
      </div>
      <v-btn
        icon
        :disabled="disabled || !nextPageAvailable"
        @click="$emit('page-change', page + 1)"
      >
        <v-icon size="24">mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import PerPageSelect from "@/components/List/PerPageSelect";
import cuid from "cuid";

export default {
  name: "PaginationSimple",
  inheritAttrs: false,
  components: {
    PerPageSelect
  },
  props: {
    page: {
      type: Number,
      required: true,
      validator: value => value > 0
    },
    perPage: {
      type: Number,
      required: true,
      validator: value => value > 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => [5, 10, 15],
      validator: value => value.every(num => Number.isInteger(num) && num > 0)
    },
    nextPageAvailable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showPerPage: {
      type: Boolean,
      default: true
    },
    center: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      perPageOptions: [],
      localPage: 1
    };
  },
  computed: {
    selectedPerPage() {
      return (
        this.perPageOptions.find(({ value }) => value === this.perPage) ||
        this.perPageOptions[0]
      );
    }
  },

  mounted() {
    this.initOptions();
  },
  methods: {
    initOptions() {
      this.perPageOptions = this.options.map(size => ({
        name: this.getOptionLabel(size),
        value: size,
        id: cuid()
      }));
    },

    onPerPageChange(e) {
      this.$emit("per-page-change", e.value);
    },

    getOptionLabel(value) {
      return this.$t("message.common.show", [value]);
    }
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 22px;
  justify-content: space-between;
  flex-grow: 1;

  &--center {
    justify-content: center;
  }

  &__dropdown {
    ::v-deep .v-input {
      border-radius: 30px;
      box-shadow: 0px 0px 30px rgba(54, 60, 86, 0.07);
    }
  }

  &__nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    user-select: none;
    gap: $spacing * 2;
  }

  &__counter {
    font-weight: normal;
    @include font-size(14px);
    line-height: 17px;
    color: $text;
  }
}
</style>
